<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <fragment v-if="form">
      <EndorsementForm
        :form="form"
        @submit="submit"
        name-button="SALVAR"
        :is-edit="canEditEndorsement"
        :can-request-cancel="canRequestCancelEndorsement"
        @cancel="previousPage"
      />
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPage"
      title="ENDOSSO EDITADO"
      text="O endosso foi editado com sucesso."
    />
    <ModalCancelEndoserment
      @close="closeModalCancel"
      v-model="modalCancelEndoserment"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import EndorsementForm from "../components/EndorsementForm";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";
import PolicyMixin from "@/mixins/PolicyMixin";
import EndorsementMixin from "@/mixins/EndorsementMixin";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelEndoserment from "../../insurance_company/components/ModalCancelInsurance";
import FormMixin from "@/mixins/FormMixin";
export default {
  data: () => ({
    form: null,
    formatDateToDDMMYYYY,
    modal: false,
    cloneForm: {}
  }),
  components: {
    EndorsementForm,
    ModalGenericCriticism,
    ModalCancelEndoserment
  },
  mixins: [LoadingRequest, PolicyMixin, EndorsementMixin, FormMixin],
  created() {
    this.withLoading(
      Promise.all([
        this.requestItemsEndorsement(this.$route.params.id),
        this.requestListTypeEndorsement(),
        this.requestCurrentPolicy(this.$route.params.id),
        this.requestPaymentMethods()
      ])
    );
  },
  computed: {
    ...mapState("policy", ["currentEndorsement", "currentPolicy"]),
    emptyCurrentPolicy() {
      return !this.currentPolicy.tomador.nome_fantasia;
    },
    canEditEndorsement() {
      return this.currentEndorsement.acoes?.pode_editar;
    },
    canRequestCancelEndorsement() {
      return this.currentEndorsement.acoes?.pode_cancelar;
    },
    breadcrumb() {
      return [
        {
          text: this.canEditEndorsement
            ? "Editar Endosso"
            : "Visualizar Endosso",
          to: "policy"
        }
      ];
    }
  },
  methods: {
    ...mapActions("policy", [
      "requestListTypeEndorsement",
      "requestCurrentEndorsement",
      "requestEditEndorsement",
      "requestCurrentPolicy",
      "requestItemsEndorsement"
    ]),
    ...mapActions("insuranceCompany", ["requestPaymentMethods"]),
    async submit(form) {
      this.withLoading(
        this.requestEditEndorsement(
          await this.payloadEditEndorsement(form)
        ).then(() => {
          this.modal = true;
          this.cancel = true;
        })
      );
    },
    async payloadEditEndorsement(form) {
      return {
        id: this.$route.params.id,
        payload: await this.getPayloadEndorsement(form),
        endosso: this.$route.params.endosso
      };
    },
    getIdsPayload() {
      return {
        id: this.$route.params.id,
        endosso: this.$route.params.endosso
      };
    },
    updateForm() {
      this.form = _.cloneDeep(this.currentEndorsement);
      
      if(this.currentEndorsement.arquivo) {
        this.form.apolice = [this.currentEndorsement.arquivo];
      }
      else {
        this.form.apolice = [];
      }

      this.form.fim_vigencia_atual =
        this.currentEndorsement.fim_vigencia &&
        this.formatDateToDDMMYYYY(this.currentEndorsement.fim_vigencia);
      this.form.importancia_segurada_atual = _.clone(
        this.currentEndorsement.valor_importancia_segurada
      );
      this.form.fim_vigencia = this.formatDateToDDMMYYYY(
        this.currentEndorsement.fim_vigencia
      );
      this.form.inicio_vigencia = this.formatDateToDDMMYYYY(
        this.currentEndorsement.inicio_vigencia
      );
      this.form.emitida_em = this.formatDateToDDMMYYYY(
        this.currentEndorsement.emitida_em
      );
      if (this.form.data_prorrogacao)
        this.form.data_prorrogacao = this.formatDateToDDMMYYYY(
          this.form.data_prorrogacao
        );
      if (this.form.cancelado_em)
        this.form.cancelado_em = this.formatDateToDDMMYYYY(
          this.form.cancelado_em
        );
      if (this.form.baixada_em)
        this.form.baixada_em = this.formatDateToDDMMYYYY(this.form.baixada_em);
      if (this.form.novo_fim_vigencia)
        this.form.novo_fim_vigencia = this.formatDateToDDMMYYYY(
          this.form.novo_fim_vigencia
        );
      if (this.form.parcelas) {
        this.form.parcelas.forEach((item, key) => {
          item.vencimento = this.formatDateToDDMMYYYY(item.vencimento);
          item.numero = key + 1;
        });

        this.form.numero_parcela = this.form.parcelas.length;
        if (this.form.parcelas.length > 0 && this.form.parcelas[0].vencimento) {
          this.form.data_vencimento = this.form.parcelas[0].vencimento;
        }
      }

      if (this.form.tipos_efeitos && this.form.tipos_efeitos.length > 0) {
        this.form.tipo_efeito_termino = [
          "alterar_termino_vigencia",
          "prorrogar_vigencia_importancia_segurada",
          "alteracoes_diversas"
        ].includes(this.form.tipo.id)
          ? _.cloneDeep(this.form.tipos_efeitos[0])
          : null;
        this.form.tipo_efeito_vigencia = [
          "importancia_segurada",
          "prorrogar_vigencia_importancia_segurada",
          "alterar_cobertura",
          "aniversario_apolice",
          "alteracoes_diversas"
        ].includes(this.form.tipo.id)
          ? this.form.tipos_efeitos.length == 1
            ? _.cloneDeep(this.form.tipos_efeitos[0])
            : _.cloneDeep(this.form.tipos_efeitos[1])
          : null;
      }
      if (!this.form.novo_fim_vigencia) delete this.form.novo_fim_vigencia;
      if (!this.form.motivo_cancelamento)
        this.form.motivo_cancelamento = {
          id: "00000000-0000-0000-0000-000000000000",
          descricao: "OUTRO"
        };
      if (!this.form.origem_cadastro) {
        this.form.origem_cadastro = { nome: "CADASTRO LSP" };
      }
      this.cloneForm = _.cloneDeep(this.form);
    },
    previousPage() {
      this.modal = false;
      this.$router.push({
        name: "details policy",
        params: { id: this.$route.params.id }
      });
    }
  },
  watch: {
    currentEndorsement() {
      this.updateForm();
    },
    currentPolicy() {
      this.withLoading(this.requestCurrentEndorsement(this.getIdsPayload()));
    }
  }
};
</script>
